import { FC, useCallback } from 'react';

import { useRouter } from 'next/router';

import { Button, Text } from '@olist/united';

import { VNDA_SUPPORT_EMAIL } from 'modules/common/constants';
import { ROUTES } from 'modules/routes';

interface Props {
  email: string;
}

export const Success: FC<Props> = ({ email }) => {
  const router = useRouter();

  const onClick = useCallback(() => {
    router.push(ROUTES.SIGNIN);
  }, [router]);

  return (
    <div>
      <Text my={16}>
        As instruções para redefinir sua senha foram enviadas para <b>{email || 'seu email'}</b>.
      </Text>
      <Text my={16}>Não esqueça de verificar também a pasta de spam do seu e-mail.</Text>
      <Text my={16}>
        Caso tenha alguma dificuldade, entre em contato com <b>{VNDA_SUPPORT_EMAIL}</b>.
      </Text>
      <Button fullWidth onClick={onClick}>
        voltar
      </Button>
    </div>
  );
};
